import React, { useState, useEffect } from "react";
import { Table, Spin } from "antd";
import Column from "antd/lib/table/Column";
import { useFetchContexts } from "../../../../apis/swr/fetchers";

interface IAccountContextsProps {
  params: { id: string };
}

const AccountContexts: React.FC<IAccountContextsProps> = ({ params }) => {
  const { contexts, isLoading } = useFetchContexts();
  const [accountIds, setAccountIds] = useState<string[]>([]);

  useEffect(() => {
    if (contexts) {
      const idArr: string[] = [];
      contexts.map((context) => {
        return idArr.push(context.accountId);
      });
      setAccountIds(idArr);
    }
  }, [contexts]);

  if (accountIds.includes(params.id)) {
    return (
      <Spin spinning={isLoading}>
        <div>
          <Table dataSource={contexts} rowKey={"confGroupId"}>
            <Column
              title="Name"
              dataIndex="name"
              key="name"
              sorter={(a: { name: string }, b: { name: string }) =>
                ("" + a.name).localeCompare(b.name)
              }
            />
            <Column
              title="Conference Group Id"
              dataIndex="confGroupId"
              key="confGroupId"
              sorter={(
                a: { confGroupId: string },
                b: { confGroupId: string }
              ) => ("" + a.confGroupId).localeCompare(b.confGroupId)}
            />
            <Column
              title="Bucket Id"
              dataIndex="bucketId"
              key="bucketId"
              sorter={(a: { bucketId: string }, b: { bucketId: string }) =>
                ("" + a.bucketId).localeCompare(b.bucketId)
              }
            />
          </Table>
        </div>
      </Spin>
    );
  } else
    return (
      <Spin spinning={isLoading}>
        <Table></Table>
      </Spin>
    );
};

export default AccountContexts;
